module.exports = __webpack_public_path__ + "static/media/logo-up.a7c4950f.png";